import { IProductData, EasyfyEventData, IBasket, IDataMapper, IEasyfyEvent, IPageViewData } from "@shared/easyfy.events/easyfy.eventdata";
import { EventNames } from "@shared/easyfy.events/easyfy.eventhandler";

/* Exporter class */
export class KlaviyoDataMapper implements IDataMapper {
  MapEventData(event: IEasyfyEvent): any {
    var mappedEvent: any;

    switch (event.eventName.toLowerCase()) {

      case EventNames.ProductPageView: {
        mappedEvent = this.ViewItemEvent(event);
        break;
      }
      case EventNames.PageView: {
        mappedEvent = this.PageViewEvent(event);
        break;
      }
      case EventNames.AddToCart: {
        mappedEvent = this.AddToCartEvent(event);
        break;
      }
      case EventNames.StartedCheckout: {
        mappedEvent = this.StartedCheckoutEvent(event);
        break;
      }
      case EventNames.CompletedCheckout: {
        mappedEvent = this.CompletedCheckoutEvent(event);
        break;
      }
      case EventNames.LoggedIn: {
        mappedEvent = this.LoggedInEvent(event);
        break;
      }
      case EventNames.LoggedOut: {
        mappedEvent = this.LoggedOutEvent(event);
        break;
      }
      // more events to come here...
    }
    return mappedEvent;
  }


  ViewItemEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) throw new Error('Product identifier missing');

    var product = EasyfyEventData.Product<KlaviyoProduct>(event.data.productIdentifier);
    var siteInfo = EasyfyEventData.SiteInfo();

    var klaviyoEvent = {
      event: "Viewed Product",
      data: {
        ProductName: product.DisplayName,
        ProductID: product.Id,
        Brand: product.Brand,
        ProductType: product.ProductType,
        Flavour: product.Flavour,
        Format: product.Format,
        Price: product.Price,
        PriceExVat: product.PriceExVat,
        Currency: siteInfo.currencyCode,
        CampaignCode: product.CampaignCode
      }
    };

    return klaviyoEvent;
  }


  PageViewEvent(event: IEasyfyEvent): any {
    var data = event.data as IPageViewData;
    var klaviyoEvent = {
      event: "Viewed Page",
      data: {
        Path: window.location.pathname,
        FullPath: window.location.href,
        PageId: data.pageId,
        TimeStampUtc: (new Date).toISOString()
      }
    };

    return klaviyoEvent;
  }

  AddToCartEvent(event: IEasyfyEvent): any {
    const basket: IBasket = EasyfyEventData.Basket();
    if (basket == undefined || basket.rows == undefined || basket.rows.length == 0) {
      return;
    }
    
    var siteInfo = EasyfyEventData.SiteInfo();
    const items: any[] = [];
    const itemNames: string[] = [];
    basket.rows.forEach((basketProduct) => {
      var product = EasyfyEventData.Product<KlaviyoProduct>(basketProduct.productIdentifier);
      items.push({
        ProductID: product.Id,
        SKU: product.Id,
        ProductName: product.DisplayName,
        Quantity: basketProduct.qty,
        ItemPrice: product.Price,
        RowTotal: product.Price * basketProduct.qty,
        ProductURL: product.AbsoluteProductUrl,
        ImageURL: product.ProductImageUrl,
        ProductCategories:
          product.Categories.length > 0 ? product.Categories.toString() : [product.ProductType],
        Brand: product.Brand,
      });
      itemNames.push(product.DisplayName);
    });
    var lastItem = items[items.length - 1];
    const klaviyoEvent = {
      event: "Added to Cart",
      data: {
        $value: basket.priceIncVat,
        AddedItemProductName: lastItem.ProductName,
        AddedItemProductID: lastItem.ProductID,
        AddedItemSKU: lastItem.SKU,
        AddedItemCategories: lastItem.ProductCategories,
        AddedItemImageURL: lastItem.ImageURL,
        AddedItemURL: lastItem.ProductURL,
        AddedItemPrice: lastItem.ItemPrice,
        AddedItemQuantity: lastItem.Quantity,
        ItemNames: itemNames.toString(),
        CheckoutURL: siteInfo.checkoutPath,
        Items: items,
        GenerateBasketUrl: basket.generateBasketUrl,
      }
    };
    return klaviyoEvent;
  }

  StartedCheckoutEvent(event: IEasyfyEvent): any {
    if (!event.data.checkoutProducts || event.data.checkoutProducts.length == 0) throw new Error('No products found');

    const basket: IBasket = EasyfyEventData.Basket();
    let items: any[] = [];
    let itemNames: string[] = [];
    let categories: Set<string> = new Set();
    let checkoutValue: any = 0;

    event.data.checkoutProducts.forEach((checkoutProduct) => {
      var product = EasyfyEventData.Product<KlaviyoProduct>(checkoutProduct.productIdentifier);
      var salesUnitPrice = EasyfyEventData.ProductSalesUnitPrice(checkoutProduct.productIdentifier + "-" + checkoutProduct.salesUnitCode);

      categories.add(product.ProductType)

      itemNames.push(product.DisplayName);

      items.push({
        ProductID: product.Id,
        SKU: product.Id,
        ProductName: product.DisplayName,
        Quantity: checkoutProduct.qty,
        ProductURL: product.AbsoluteProductUrl,
        ImageURL: product.ProductImageUrl,
        ProductCategories: product.Categories.length > 0 ? product.Categories.toString() : [product.ProductType],
      });

      checkoutValue += salesUnitPrice.priceIncVat * checkoutProduct.qty;
    });


    var siteInfo = EasyfyEventData.SiteInfo();
    var klaviyoEvent = {
      event: "Started Checkout",
      data: {
        Categories: Array.from(categories.values()),
        CheckoutURL: siteInfo.checkoutPath,
        ItemNames: itemNames,
        Items: items,
        $value: checkoutValue,
        GenerateBasketUrl: basket?.generateBasketUrl,
      }
    };

    return klaviyoEvent;
  }

  CompletedCheckoutEvent(event: IEasyfyEvent): any {
    if (event.data.registeredCustomerEmail) {
      var klaviyoEvent = {
        event: null,
        data: null,
        identify: event.data.registeredCustomerEmail
      };

      return klaviyoEvent;
    }
  }

  LoggedInEvent(event: IEasyfyEvent): any {
    var klaviyoEvent = {
      event: "Logged In",
      data: {
         email: event.data.email
      },
      identify: event.data.email
    };

    return klaviyoEvent;
  }

  LoggedOutEvent(event: IEasyfyEvent): any {
    var klaviyoEvent = {
      event: "Logged Out",
      data: {
        email: event.data.email
      }
    };

    return klaviyoEvent;
  }
}

class KlaviyoProduct implements IProductData {
  Id: any;
  Ean: any;
  DisplayName: any;
  Brand: any;
  Categories: any[];
  Price: number;
  PriceExVat: number;
  CampaignCode: string;
  Flavour: string;
  Format: string;
  ProductType: string;
  DomainId: string;
  AbsoluteProductUrl: string;
  RelativeProductUrl: string;
  ProductImageUrl: string;
}